import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router';
import { BarraLateral } from './BarraLateral';
import { BarraSuperior } from './BarraSuperior';
import { useEsEscritorio } from './useEsEscritorio';

const VERSION = '0.1.0';
const CLAVE_CONTRAIDA = 'civitas.menu.contraida';

export function Armazon() {
  const esEscritorio = useEsEscritorio();
  const [menuAbierto, setMenuAbierto] = useState(false);
  const ubicacion = useLocation();

  const [contraida, setContraida] = useState(() => {
    try {
      return localStorage.getItem(CLAVE_CONTRAIDA) === 'si';
    } catch {
      return false;
    }
  });

  function alternarContraida() {
    setContraida((previa) => {
      const siguiente = !previa;
      try {
        localStorage.setItem(CLAVE_CONTRAIDA, siguiente ? 'si' : 'no');
      } catch {
      }
      return siguiente;
    });
  }

  const [rutaPrevia, setRutaPrevia] = useState(ubicacion.pathname);
  if (ubicacion.pathname !== rutaPrevia) {
    setRutaPrevia(ubicacion.pathname);
    setMenuAbierto(false);
  }

  useEffect(() => {
    function alPulsar(evento: KeyboardEvent) {
      if (evento.key === 'Escape') {
        setMenuAbierto(false);
      }
    }
    document.addEventListener('keydown', alPulsar);
    return () => document.removeEventListener('keydown', alPulsar);
  }, []);

  return (
    <div
      className={[
        'flex min-h-dvh flex-col bg-armazon-50',

        'transition-[padding] duration-300 ease-in-out',
        contraida ? 'lg:pl-20' : 'lg:pl-72',
      ].join(' ')}
    >
      <BarraLateral
        abierta={menuAbierto}
        contraida={contraida}
        esEscritorio={esEscritorio}
        alCerrar={() => setMenuAbierto(false)}
        alAlternarContraida={alternarContraida}
        alNavegar={() => {
          if (!esEscritorio) {
            setMenuAbierto(false);
          }
        }}
      />
      <BarraSuperior alAbrirMenu={() => setMenuAbierto(true)} />

      <main className="flex-1 p-5 lg:p-8">
        <Outlet />
      </main>

      <footer className="border-t border-armazon-200 bg-white px-6 py-4">
        <div className="flex flex-col items-center justify-between gap-2 text-xs text-armazon-400 sm:flex-row">
          <p className="uppercase tracking-wide">
            © {new Date().getFullYear()}{' '}
            <span className="font-semibold text-armazon-600">EPAGAL EP</span> — Empresa Pública de
            Aseo y Gestión Ambiental del cantón Latacunga
          </p>
          <p className="uppercase tracking-wide">v{VERSION} · Desarrollado en Latacunga, Ecuador</p>
        </div>
      </footer>
    </div>
  );
}
